
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_dm8gx_1kw6u_97",
  "has-items": "awsui_has-items_dm8gx_1kw6u_107",
  "token": "awsui_token_dm8gx_1kw6u_111",
  "dismiss-button": "awsui_dismiss-button_dm8gx_1kw6u_123",
  "token-disabled": "awsui_token-disabled_dm8gx_1kw6u_157",
  "toggle": "awsui_toggle_dm8gx_1kw6u_172",
  "description": "awsui_description_dm8gx_1kw6u_233"
};
  